export default "__VITE_ASSET__0RhWUiL1__"